import dayjs from 'dayjs';

export const dateIndex = (dateArray, currentDate) => {
   return dateArray.findIndex((date) => dayjs(date).isSame(currentDate, 'date'))
}

